import {useCart} from '@shopify/hydrogen';
import clsx from 'clsx';
import {useCartUI} from './CartUIProvider.client';

type Props = {
  onClick?: () => void;
};

export default function CartToggle({onClick}: Props) {
  const {totalQuantity} = useCart();
  const {isCartOpen, toggleCart, closeCart} = useCartUI();

  if (isCartOpen === true) {
    return (
      <p
      className={clsx(
        'cursor-pointer link--nav',
        isCartOpen && 'text-main'
      )}
      aria-expanded={isCartOpen}
      aria-controls="cart"
      onClick={closeCart}
    >
      Cart
      <span className={clsx(
        'ml-fontSpace',
        isCartOpen && '!text-main',
        totalQuantity > 0 ? 'text-main' : 'text-gray',
      )}>
        {totalQuantity}
      </span>
    </p>
    )
  }

  return (
    <button
      className={clsx(
        'link--nav',
        isCartOpen && 'text-main'
      )}
      aria-expanded={isCartOpen}
      aria-controls="cart"
      onClick={() => {
        toggleCart();
        onClick?.();
      }}
    >
      Cart
      <span className={clsx(
        'ml-fontSpace',
        isCartOpen && '!text-main',
        totalQuantity > 0 ? 'text-main' : 'text-gray',
      )}>
        {totalQuantity}
      </span>
    </button>
  );
}
